import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/scss/main.scss'
import Highcharts from 'highcharts'
import Maps from 'highcharts/modules/map'
import HighchartsVue from 'highcharts-vue'
import mapData from '@highcharts/map-collection/countries/au/au-all.geo.json'

import ICountUp from 'vue-countup-v2'

import Header from '@/components/molecules/Header'
import NavMenu from '@/components/molecules/NavMenu'

import VueScrollTo from 'vue-scrollto'
// VueScrollTo.setDefaults({
//   container: 'body',
//   duration: 500,
//   lazy: false,
//   easing: 'ease',
//   offset: 0,
//   force: true,
//   cancelable: true,
//   onStart: false,
//   onDone: false,
//   onCancel: false,
//   x: false,
//   y: true
// })
Vue.use(VueScrollTo)

Vue.component('Header', Header)
Vue.component('NavMenu', NavMenu)
Vue.component('ICountUp', ICountUp)

Highcharts.setOptions({
  lang: {
    thousandsSep: ','
  },
  credits: {
    enabled: false
  }
})

Maps(Highcharts)
Highcharts.maps.myMapName = mapData
// console.info(mapData)
Vue.use(HighchartsVue)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
